import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthContext, { CacheContext } from '../contexts/index';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { IconContext } from "react-icons";
import logo from '../oscar.png'
import '../styles/navbar.css';
import { PropTypes } from 'prop-types';

const Navbar = ({ isShowtime }) => {
    const { user, isLoggedIn, logout } = useContext(AuthContext);
    const { activeParty } = useContext(CacheContext);
    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => setSidebar(true);
    const hideSidebar = () => setSidebar(false);

    return (
        <>
            <IconContext.Provider value={{ color: '#fff' }}>
                <div className="navbar justify-content-between" onBlur={hideSidebar} >
                    <Link to="#" className="menu-bars">
                        <FaIcons.FaBars onClick={showSidebar} />
                    </Link>
                    <nav className={sidebar ? 'nav-menu active' : 'nav-menu'} >
                        <ul className="nav-menu-items" onClick={hideSidebar} >
                            <li className="navbar-toggle">
                                <Link to="#" className="menu-bars">
                                    <AiIcons.AiOutlineClose />
                                </Link>
                            </li>
                            {
                                isLoggedIn
                                    ?
                                    <>
                                        <li className="nav-text">
                                            <Link to="/" ><AiIcons.AiFillHome /><span>Home</span></Link>
                                        </li>
                                        <li className="nav-text">
                                            <Link to="/party-history"><FaIcons.FaHistory /><span>Party History</span></Link>
                                        </li>
                                        <li className="nav-text">
                                            <Link to={`/party/create`}><FaIcons.FaPlusCircle /><span>Create New Party</span></Link>
                                        </li>
                                        {
                                            user && !activeParty?.isHistory && !isShowtime && activeParty?.id
                                                ?
                                                <li className="nav-text">
                                                    <Link to={`/my-picks/${activeParty.id}`}><FaIcons.FaUserCheck /><span>Set My Picks</span></Link>
                                                </li>
                                                :
                                                <></>
                                        }
                                        {
                                            user && user.email == 'jasonmonroe417@gmail.com'
                                                ?
                                                <li className="nav-text">
                                                    <Link to="/set-winners"><FaIcons.FaTrophy /><span>Set Winners</span></Link>
                                                </li>
                                                :
                                                <></>
                                        }
                                        {
                                            user && user.email == activeParty?.adminEmail && !activeParty?.isHistory
                                                ?
                                                <li className="nav-text">
                                                    <Link to="/party/update/:partyId"><FaIcons.FaEdit /><span>Update Party</span></Link>
                                                </li>
                                                :
                                                <></>
                                        }
                                        <li className="nav-text">
                                            <Link
                                                to="/"
                                                className="nav-link"
                                                onClick={() => logout()}
                                            >
                                                <FaIcons.FaSignOutAlt /><span>Logout</span>
                                            </Link>
                                        </li>
                                    </>
                                    :
                                    <li className="nav-text">
                                        <Link to="/login"><FaIcons.FaSignInAlt /><span>Login</span></Link>
                                    </li>
                            }
                        </ul>
                    </nav>
                    <h4 className="title">Oscar Parties</h4>
                    <img className="brand" src={logo} alt='logo' />
                </div>

            </IconContext.Provider>
        </>
    );
};

Navbar.propTypes = {
    isShowtime: PropTypes.bool,
    activeParty: PropTypes.object
}

export default Navbar;